import * as v from "valibot";

import { rpcContract } from "../rpc";

export const rpcName = "adminSendEmailVerify";

export const AdminSendEmailVerifyRpcContract = rpcContract({
  name: rpcName,
  paramsSchema: v.object({
    email: v.pipe(v.string(), v.minLength(1, "Email is required"), v.email("Invalid email format")),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export type AdminSendEmailVerifyParams = v.InferOutput<(typeof AdminSendEmailVerifyRpcContract)["paramsSchema"]>;
export type AdminSendEmailVerifyResult = v.InferOutput<(typeof AdminSendEmailVerifyRpcContract)["resultSchema"]>;
